<template>
  <div id="mobile">
    <div class="alert">
      <div>
        <i class="fas fa-desktop fa-2x"></i>
      </div>Our journey builder is designed for desktop only. Please try again on a computer or sign up below to have a personal demo.
    </div>
    <h1 class="bd-content-title title blue-text text-left">
      <strong>
        Visualize and Customize User
        <br />Journeys
      </strong>
    </h1>
    <p
      class="subtext mb-4 text-left"
    >Create automated, cross-channel marketing workflows using a simple, drag-and-drop interface. With Journey Builder, the power is in your hands to sculpt the perfect journey and engage your customers when it matters most.</p>
    <h5 class="bd-content-title text-black text-left mb-0">Get a quote today!</h5>

    <ContactForm />

    <div class="bottom-content pb-3">
      <h5 class="bd-content-title text-black text-left">Or contact us directly!</h5>
      <ul class="list-unstyled contact-list">
        <li>
          Phone:
          <a href="tel:`${phone}`" class="link">{{ phone }}</a>
        </li>
        <li>
          Email:
          <a href="mailto:`${email_placholder}`" class="link">{{ email_placholder }}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<style lang="scss" scoped>
#mobile {
  padding: 30px;
}
.title {
  margin-bottom: 30px;
}
.bottom-content {
  width: 100%;
}
.bd-content-title {
  font-weight: bold;
}
.contact-list {
  text-align: left;
  // display: flex;
  // justify-content: center;

  a {
    color: #03b6fc;
  }
}
.subtext {
  padding-bottom: 20px;
}
.alert {
  background: #fbb1bd;
  border: 1px solid #a50000;
  border-radius: 4px;
  text-align: left;
  color: #a50000;
  padding: 20px;
  margin-bottom: 30px;

  .fas {
    font-size: 1.2rem;
    margin-bottom: 10px;
  }
}
</style>
<script>
import axios from "axios";

import { required, email } from "vuelidate/lib/validators";
import { mapState, mapGetters, mapActions } from "vuex";
import ContactForm from "@/components/ContactForm";

export default {
  name: "Mobile",
  components: {
    ContactForm
  },
  data() {
    return {
      email_address: "",
      first_name: "",
      last_name: "",
      company: "",
      phone: "1.888.438.3152 Ext: 1",
      email_placholder: "sales@maropost.com",
      submitStatus: null
    };
  },
  props: {
    chosenIndustry: {
      type: String
    }
  },
  computed: {
    isRequired() {
      return true;
    },
    isValid() {
      return (
        this.first_name !== "" &&
        this.company !== "" &&
        this.email_address !== ""
      );
    }
  },
  mounted() {},
  validations: {
    email_address: {
      email,
      required: true,
      async isUnique(value) {
        // standalone validator ideally should not assume a field is required
        if (value === "") return true;

        // simulate async call, fail for all logins with even length
        return new Promise((resolve, reject) => {
          setTimeout(() => {
            resolve(typeof value === "string" && value.length % 2 !== 0);
          }, 350 + Math.random() * 300);
        });
      }
    },
    first_name: { required: true },
    last_name: { required: false },
    company: { required: true }
  },
  methods: {
    async submit() {
      this.$v.$touch();

      if (!this.isValid) {
        this.submitStatus = "ERROR";
      } else {
        this.submitStatus = "PENDING";

        const data = {
          email: this.email_address,
          first_name: this.first_name,
          last_name: this.last_name,
          company: this.company
        };

        try {
          let res = await axios({
            method: "post",
            url: "http://go.maropost.com/l/597851/2020-05-13/cnhcb",
            data
          });

          console.log("res", res);
          this.submitStatus = "OK";

          this.$ga.event({
            eventCategory: "Subscribe",
            eventAction: "submit",
            eventValue: opts
          });
        } catch (error) {
          console.log(error);
          this.submitStatus = "ERROR";
        }
      }
    }
  }
};
</script>
